.kbd {
  appearance: none;
  background: none;
  border: none;
  outline: none;
  box-shadow: none;
  color: inherit;
  padding: 0;
  border-radius: 0;
  font-weight: inherit;
  font-family: inherit;
  font-size: inherit;

  &.simple {
    padding: 2px 4px;
    border-radius: 2px;
    background-color: rgba(255, 255, 255, 0.2);
  }
}
